import { TabContext, TabList } from '@mui/lab';
import { styled, Tab } from '@mui/material';
import { Box } from '@mui/system';
import FlexBox from 'components/flexbox/FlexBox';
import { H5 } from 'components/Typography';

const Wrapper = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
}));

const TabListWrapper = styled(TabList)(({ theme }) => ({
    [theme.breakpoints.down(727)]: {
        order: 3,
    },
}));

const HeadingArea = ({ value, changeTab, header, title = 'Invoice List' }) => {
    return (
        <Wrapper gap={1}>
            <FlexBox alignItems="center">
                <H5>{title}</H5>
            </FlexBox>

            <TabContext value={value}>
                <TabListWrapper variant="scrollable" onChange={changeTab}>
                    <Tab
                        disableRipple
                        label={`All (${header.reduce(
                            (acc, cur) => acc + cur.count,
                            0,
                        )})`}
                        value="all"
                        sx={{
                            color: '#424242',
                            backgroundColor:'#eeeeee',
                            marginRight: 0.5,
                            borderRadius: 1,
                        }}
                    />
                    {header &&
                        header.map((item, index) => (
                            <Tab
                                disableRipple
                                sx={{
                                    color: item?.status?.color || '#424242',
                                    backgroundColor:
                                        item?.status?.bgColor || '#eeeeee',
                                    borderRadius: 1,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    minHeight: 32,
                                    marginRight: 0.5,
                                    '&.Mui-selected': {
                                        color:
                                            item?.status?.color || '#424242',
                                        backgroundColor:
                                            item?.status?.bgColor || '#eeeeee',
                                    },
                                }}
                                label={
                                    item.status.label + ' (' + item.count + ')'
                                }
                                value={item.status.value}
                                key={index}
                            />
                        ))}
                </TabListWrapper>
            </TabContext>
        </Wrapper>
    );
};

export default HeadingArea;
